import { render, staticRenderFns } from "./DeleteBuddyBot.vue?vue&type=template&id=15b06d82&scoped=true"
import script from "./DeleteBuddyBot.vue?vue&type=script&lang=js"
export * from "./DeleteBuddyBot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b06d82",
  null
  
)

export default component.exports